import styled from 'styled-components'

import { ProductLogo as DefaultProductLogo } from '@subaio/components'

import { helpers } from 'styles'

export const ProductLogo = styled(DefaultProductLogo).attrs(({ title }) => ({
	border: false,
	background: title ? '#37ABA1' : undefined,
}))`
	flex-shrink: 0;
	border: none;
	color: ${helpers.color.textInverted};
`
